export enum MarkerType {
  TwoDimensional = 1,
  ThreeDimensional = 2,
}

export interface CreateWoundModelNoteRequest {
  woundId: string;
  markerType: MarkerType;
  fileName: string;
  note: string;
  positionData: string;
}

export interface CreateWoundModelNoteResponse {
  id: string;
}
